export const getGroupedSectionCardsMap = sectionCards => {
  // Create a Map to store the grouped sectionCards based on the tabs
  const groupedSectionCardsMap = new Map()

  // Iterate through the sectionCards array and group them by tabSection
  sectionCards.forEach(card => {
    const { tabSection } = card
    if (groupedSectionCardsMap.has(tabSection)) {
      groupedSectionCardsMap.get(tabSection).push(card)
    } else {
      groupedSectionCardsMap.set(tabSection, [card])
    }
  })

  return groupedSectionCardsMap
}

function sanitizeSelector(selector) {
  // Replace invalid characters with an empty string
  return selector.replace(/[!"#$%&'()*+,.\/:;<=>?@[\\\]^`{|}~]/g, '')
}

export function convertToClassName(inputString) {
  if (inputString === null) {
    return ''
  }

  // Remove spaces and convert to lowercase
  const lowercased = inputString.toLowerCase()

  // Replace spaces with underscores
  const underscores = lowercased.replace(/\s+/g, '_')
  const sanitizedSelector = sanitizeSelector(underscores)
  return sanitizedSelector
}
